import React, { useEffect, useState } from "react";
import SidebarContainer from "../Sidebar/SidebarContainer";
import { Outlet, useLocation } from "react-router-dom";
import { USER_ROLE } from "../../../core/Constant";
import { Actions } from "../../../core/modules/Actions";
import { useDispatch } from "react-redux";
import { NetwokIssueScreen } from "../../../module";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
const QUIZ_FOCUS_EVENT = "quiz-focus-mode";



const Layout = ({ userRole }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [quizFocusLocked, setQuizFocusLocked] = useState(false);

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    dispatch(Actions.common.getActiveFlag());
  }, []);

  useEffect(() => {
    const onQuizFocus = (e) => {
      setQuizFocusLocked(Boolean(e.detail?.locked));
    };
    window.addEventListener(QUIZ_FOCUS_EVENT, onQuizFocus);
    return () => window.removeEventListener(QUIZ_FOCUS_EVENT, onQuizFocus);
  }, []);

  useEffect(() => {
    if (location.pathname !== "/quiz-main") {
      setQuizFocusLocked(false);
    }
  }, [location.pathname]);

  const isStudentLayout =
    localStorage.getItem("userType") == USER_ROLE.student;
  const lockNavChrome =
    quizFocusLocked &&
    isStudentLayout &&
    location.pathname === "/quiz-main";

  const [open, setOpen] = React.useState(false);

  const handleDrawer = () => {
    setOpen(open ? false : true);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        sx={{
          position: "relative",
          height: "100%",
          ...(lockNavChrome
            ? {
                pointerEvents: "none",
                opacity: 0.55,
                userSelect: "none",
                "& .MuiDrawer-root": { pointerEvents: "none" },
                "& .MuiDrawer-paper": { pointerEvents: "none" },
              }
            : {}),
        }}
      >
        <Box
          sx={{
            position: "absolute",
            right: 15,
            top: 68,
            zIndex: 1300,
            ...(lockNavChrome ? { pointerEvents: "none" } : {}),
          }}
        >
          <div style={{ position: "fixed" }}>
            <IconButton
              onClick={handleDrawer}
              
              sx={{
                bgcolor: "#fff",
                ":hover": { bgcolor: "rgb(152, 52, 240);", color: "#fff" },
                width: 28,
                height: 28,
                boxShadow:'0 0px 0px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);'
              }}
            >
              {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
          </div>
        </Box>
        <SidebarContainer
          type={
            localStorage.getItem("userType") == USER_ROLE.admin
              ? "admin"
              : "student"
          }
          open={open}
          handleDrawer={handleDrawer}
        />
      </Box>

      <Box component="main"sx={{flexGrow: 1, pl: 3, pr: 3, pb: 2, pt: 0, pointerEvents: lockNavChrome ? "auto" : undefined}}>
        {isOnline ? <Outlet /> : <NetwokIssueScreen />}
      </Box>
    </Box>
  );
};

export default Layout;
